import { IParamsOption, IRequestFetcherOptions } from 'src/common/razzle-platform-components/types'
import { fetchSpecificitiesOfProduct } from 'src/common/razzle-platform-specificityofproduct/effects'
import { Store } from 'src/redux'

// we fixed this SPECIFICITIES_OF_PRODUCT_PROPS_ID for use it to save our props in reudcer
export const SPECIFICITIES_OF_PRODUCT_PROPS_ID = 'specificitiesOfProductProps'

// we use ths function to get the specificities of product on the server side
export async function getInitialPropsOfSpecificitiesOfProduct(context, store: Store, options: Pick<IParamsOption, 'params'> = {}) {
    try {

		const { dispatch, getState } = store

		// in specificities of product we need params for make forced request exmaple: parms: { _embed: [user, ...etc]}
		const queryOptions: Pick<IRequestFetcherOptions, 'params'> = {
			params: options.params,
		}

		// get the locale
		const locale: string = getState().translationModel.locale

		// set the Accept-Language to the headers of the request for get the translated data
		const headers = { "Accept-Language": locale }

		// get the specificities of product by execute the effect fetchSpecificitiesOfProduct and pass it queryOptions
		const { specificitiesOfProduct } = await fetchSpecificitiesOfProduct(queryOptions, headers)

		// save the initialProps in the reducer
		dispatch.ssrModel.setInitialProps({ [SPECIFICITIES_OF_PRODUCT_PROPS_ID]: { specificitiesOfProduct, queryOptions } })

	} catch (error) {
        console.log('errrrorrrr', error)
	}
}
